import { render, staticRenderFns } from "./Two_FA_Modal.vue?vue&type=template&id=4bc94242&scoped=true"
import script from "./Two_FA_Modal.vue?vue&type=script&lang=js"
export * from "./Two_FA_Modal.vue?vue&type=script&lang=js"
import style0 from "./Two_FA_Modal.vue?vue&type=style&index=0&id=4bc94242&prod&scoped=true&lang=css"
import style1 from "./Two_FA_Modal.vue?vue&type=style&index=1&id=4bc94242&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc94242",
  null
  
)

export default component.exports